<template>
    <div class="row">
        <input-select class="col-12 col-md-6" label="Empresa receptora" ref="empresa" required :options="options.empresas" v-model="form.empresa"/>
        <input-select class="col-12 col-md-6" label="Tipo de laboratório" ref="tipo" required :options="options.tipo" v-model="form.tipo"/>
        <input-textarea class="col-12" label="Nome do laboratório" :max-length="100" placeholder="Máximo 100 caracteres" ref="laboratorio" required v-model="form.laboratorio"/>
        <input-text class="col-12" label="Área de pesquisa" :max-length="50" placeholder="Máximo 50 caracteres" ref="unidade" required v-model="form.areaPesquisa"/>
        <input-textarea class="col-12" label="Lista de materiais" :max-length="300" placeholder="Máximo 300 caracteres" ref="materiais" required v-model="form.listaMateriais"/>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect.vue";
import InputText from "@/components/inputs/InputText.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";

import helpers from "@/common/utils/helpers";

import ProjetoService from "@/common/services/projeto/projeto.service";

import {FormMixin} from "@/common/mixins/FormMixin";
import cloneDeep from "lodash/cloneDeep";

export default {
    name: "ModalApoioInfraestrutura",
    mixins: [FormMixin],
    props : {
        projetoId: {
            type: String,
            required: true
        },
    },
    components: {
        InputSelect,
        InputText,
        InputTextarea
    },    
    data : () => ({
        form : {
            id: null,
            empresa: null,
            tipo: null,
            laboratorio: "",
            areaPesquisa: "",
            listaMateriais: "",            
        },
        options : {
            tipo : helpers.getTiposApoioInfraEstrutura(),
            empresas : [],
        }
    }),
    methods : {
        salvar : function(){
            let form = cloneDeep(this.form);
            form = Object.assign({}, form, this.options.empresas.find(el => el.value == form.empresa).el);
            this.$emit('salvar', form);
        },
        editar : function(e){
            let form = cloneDeep(e);
            this.form = form;
            this.form.empresa = form.projetoEmpresaInvestidoraId 
                                || form.projetoCooperadaId 
                                || form.projetoEmpresaExecutoraCriadoraReceptoraId
                                || form.projetoEmpresaExecutoraReceptoraId
                                || form.projetoExecutoraCriadoraId
                                || form.projetoExecutoraId
                                || form.projetoInvestidoraId

        },

        buscarEmpresas : function(){
            
            ProjetoService.listarEmpresasAssociadas(this.projetoId).then(response => {
                this.options.empresas = response.data.data.map(el => {
                    return {
                        value : el.projetoEmpresaExecutoraCriadoraReceptoraId || 
                                el.projetoEmpresaExecutoraReceptoraId,
                        text : el.razaoSocial,
                        el : el
                    }
                });
            });
        }
    },
    mounted(){
        this.buscarEmpresas();
    },
}
</script>
<style lang="">
    
</style>